import React, { Component } from 'react';
import classNames from 'classnames';
import ui from 'config/css/ui';
import withStyles from 'isomorphic-style-loader/withStyles';
import ShareButtons from 'components/shareButtons';

import styles from './stickyShareButtons.css';

class StickyShareButtons extends Component {
  constructor(props) {
    super(props);
    this.topPin = null;
    this.bottomPin = null;

    this.state = {
      isStickyTop: false,
      isStickyBottom: false,
    };
  }

  componentDidMount() {
    this.intersectionObserverForTopPin = new IntersectionObserver(
      ([entry]) => this.setState({ isStickyTop: 1 > entry.intersectionRatio }),
      {
        rootMargin: `-${ui['--headerHeight']}px 0px 1000000% 0px`,
        // Intersection will be detected when viewport top + headerHeight (134px) will reach the observed element
        // Setting rootMargin bottom to 1000000% will make sure the observed element will never intersect with the bottom of viewport
        threshold: 1,
      },
    );

    this.intersectionObserverForBottomPin = new IntersectionObserver(
      ([entry]) => this.setState({ isStickyBottom: 1 > entry.intersectionRatio }),
      {
        rootMargin: `-${ui['--headerHeight'] + ui['--shareButtonsHeight'] + ui['--shareButtonsBottomMargin']}px 0px 1000000% 0px`,
        // Intersection will be detected when viewport top + (headerHeight (134px) + ShareButtons height (254px)) + ShareButtonsBottomMargin (20px) will reach the observed element
        // Setting rootMargin bottom to 1000000% will make sure the observed element will never intersect with the bottom of viewport
        threshold: 1,
      },
    );

    this.intersectionObserverForTopPin.observe(this.topPin);
    this.intersectionObserverForBottomPin.observe(this.bottomPin);
  }

  componentWillUnmount() {
    this.intersectionObserverForTopPin.unobserve(this.topPin);
    this.intersectionObserverForBottomPin.unobserve(this.bottomPin);
  }

  render() {
    return (
      <aside>
        <div ref={(topPin) => { this.topPin = topPin; }} />
        <div
          className={classNames(styles.stickyShareButtons, {
            [styles.stickToTop]: this.state.isStickyTop,
            [styles.stickToBottom]: this.state.isStickyBottom,
          })}
        >
          <ShareButtons isColumn {...this.props} />
        </div>
        <div ref={(bottomPin) => { this.bottomPin = bottomPin; }} />
      </aside>
    );
  }
}

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(StickyShareButtons);
